'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _matrixJsSdk = require('matrix-js-sdk');

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _ContextualMenu = require('../../structures/ContextualMenu');

var _EventUtils = require('../../../utils/EventUtils');

var _RoomView = require('../../structures/RoomView');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RELATION_EVENTS = ["Relations.add", "Relations.remove", "Relations.redaction"];

var MessageDelivery = function (_React$PureComponent) {
    (0, _inherits3.default)(MessageDelivery, _React$PureComponent);

    function MessageDelivery(props) {
        (0, _classCallCheck3.default)(this, MessageDelivery);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageDelivery.__proto__ || (0, _getPrototypeOf2.default)(MessageDelivery)).call(this, props));

        _this.onFocusChange = function (focused) {
            if (!_this.props.onFocusChange) {
                return;
            }
            _this.props.onFocusChange(focused);
        };

        _this.onRelationCreated = function () {
            var _this$props = _this.props,
                mxEvent = _this$props.mxEvent,
                deliveryStateOptions = _this$props.deliveryStateOptions;
            var roomContext = _this.context.room;


            if (!roomContext || !roomContext.room || !roomContext.room.timelineSets) return null;
            var timelineSet = roomContext.room.timelineSets[0];
            if (!timelineSet) return null;

            var relation = timelineSet.getRelationsForEvent(mxEvent.getId(), "g.annotation", "g.delivery");
            mxEvent.removeListener("Event.relationsCreated", _this.onRelationCreated);
            var deliveryState = (0, _EventUtils.getBridgeDeliveryState)(roomContext.room, mxEvent, deliveryStateOptions);

            if (relation) {
                RELATION_EVENTS.forEach(function (eventType) {
                    relation.on(eventType, _this.onRelationChange);
                });
            }
            _this.setState({
                relation: relation,
                deliveryState: deliveryState
            });
        };

        _this.onRelationChange = function () {
            var room = _this.context.room.room;
            var _this$props2 = _this.props,
                mxEvent = _this$props2.mxEvent,
                deliveryStateOptions = _this$props2.deliveryStateOptions;


            _this.setState({
                deliveryState: (0, _EventUtils.getBridgeDeliveryState)(room, mxEvent, deliveryStateOptions)
            });
        };

        _this.getMenuOptions = function (ev) {
            var menuOptions = {};
            var gutter = 12;
            var deliveryIconWidth = 100 + gutter;

            var buttonRect = ev.target.getBoundingClientRect();
            // The window X and Y offsets are to adjust position when zoomed in to page
            var buttonLeft = buttonRect.left + window.pageXOffset;
            var buttonBottom = buttonRect.bottom + window.pageYOffset;
            var buttonTop = buttonRect.top + window.pageYOffset;
            // Align the right edge of the menu to the right edge of the button
            menuOptions.left = buttonLeft + gutter;
            if (menuOptions.left + deliveryIconWidth > window.innerWidth) {
                menuOptions.left = window.innerWidth - deliveryIconWidth - gutter;
            }
            // Align the menu vertically on whichever side of the button has more
            // space available.
            if (buttonBottom < window.innerHeight / 2) {
                menuOptions.top = buttonBottom;
            } else {
                menuOptions.bottom = window.innerHeight - buttonTop;
            }
            return menuOptions;
        };

        _this.onOptionsClick = function (ev) {
            var _this$props3 = _this.props,
                mxEvent = _this$props3.mxEvent,
                disableContextMenu = _this$props3.disableContextMenu;
            var deliveryState = _this.state.deliveryState;

            if (deliveryState !== 'error' || disableContextMenu) return;

            var MessageContextMenu = _index2.default.getComponent('context_menus.MessageContextMenu');

            var menuOptions = (0, _extends3.default)({}, _this.getMenuOptions(ev), {
                mxEvent: mxEvent,
                chevronFace: "none",
                showCancel: true,
                showResend: true,
                showRedact: true,
                onFinished: function onFinished() {
                    _this.onFocusChange(false);
                }
            });

            (0, _ContextualMenu.createMenu)(MessageContextMenu, menuOptions);

            _this.onFocusChange(true);
        };

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(MessageDelivery, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var mxEvent = this.props.mxEvent;

            this.onRelationCreated();
            mxEvent.on("Event.relationsCreated", this.onRelationCreated);
            mxEvent.on("Event.status", this.onRelationChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this2 = this;

            var mxEvent = this.props.mxEvent;

            mxEvent.removeListener("Event.relationsCreated", this.onRelationCreated);
            var relation = this.state.relation;

            if (relation) {
                RELATION_EVENTS.forEach(function (eventType) {
                    relation.removeListener(eventType, _this2.onRelationChange);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var disableContextMenu = this.props.disableContextMenu;
            var deliveryState = this.state.deliveryState;

            if (!deliveryState) return null;

            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');

            // aria-live=off to not have this read out automatically as navigating around timeline, gets repetitive.
            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)("mx_MessageDelivery", { mx_MessageDelivery_disabled: disableContextMenu })
                },
                _react2.default.createElement(AccessibleButton, {
                    className: (0, _classnames2.default)("mx_MessageDelivery_maskButton", {
                        mx_MessageDelivery_errorIndicator: deliveryState === 'error',
                        mx_MessageDelivery_pendingIndicator: deliveryState === 'pending',
                        mx_MessageDelivery_sentIndicator: deliveryState === 'sent'
                    }),
                    title: (0, _languageHandler._t)(disableContextMenu ? "Context menu has been disabled" : deliveryState),
                    onClick: this.onOptionsClick
                })
            );
        }
    }]);
    return MessageDelivery;
}(_react2.default.PureComponent);

MessageDelivery.propTypes = {
    mxEvent: _propTypes2.default.object.isRequired,
    disableContextMenu: _propTypes2.default.bool
};
MessageDelivery.defaultProps = {
    disableContextMenu: false
};
MessageDelivery.contextTypes = {
    room: _RoomView.RoomContext,
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};
exports.default = MessageDelivery;
module.exports = exports['default'];
//# sourceMappingURL=MessageDelivery.js.map